import React from "react";
import FeatherIcon from "feather-icons-react";
import { ReactComponent as LogoutIcon } from "../icons/log-out.svg";
import { ReactComponent as ClockIcon } from "../icons/clock.svg";
import { ReactComponent as ReloadIcon } from "../icons/reload.svg";
import { filterItems, handleLinkClick } from "../../utils";
import { useAppState } from "../../context/appContex";

const ActionDropDown: React.FC<{
  top: number;
}> = ({ top }) => {
  const { menuData, languages, init, user, renderFlag } = useAppState();

  const { infoGroup, settingsGroup, authGroup } = filterItems(
    menuData?.system?.items || [],
    ["sys-menu-terms", "sys-menu-help"]
  );

  return (
    <div className='action-bar' style={{ top: `${top}px` }}>
      <div className='languages'>
        {languages.map((lang) => {
          return (
            <div
              className='language-item text-with-icon'
              key={lang.isoCode}
              onClick={() => {
                window.location.href = lang.targetUrl;
              }}
            >
              <div className='right text-with-icon'>
                {renderFlag(lang.isoCode)}
                <a href={lang.targetUrl} className='drop-text'>
                  {lang.nativeName}
                </a>
              </div>
              {lang.isActive && <FeatherIcon icon='check' size={20} />}
            </div>
          );
        })}
      </div>
      <div className='drop-divider'></div>
      <div className='item'>
        {infoGroup.map((info) => {
          return (
            <div
              key={info.id}
              className='flex-item text-with-icon'
              onClick={(e) => {
                e.stopPropagation();
                handleLinkClick(info.targetUrl, true);
                return;
              }}
            >
              {info.iconClass ? (
                <FeatherIcon icon={info.iconClass} height='24px' width='24px' />
              ) : (
                <FeatherIcon icon='info' height='24px' width='24px' />
              )}
              {info.targetType === "BLANK" || info.targetType === "POPUP" ? (
                <a
                  href={info.targetUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='drop-text'
                >
                  {info.title}
                </a>
              ) : (
                <a href={info.targetUrl} className='drop-text'>
                  {info.title}
                </a>
              )}
            </div>
          );
        })}
        <div
          className='flex-item info-group text-with-icon'
          onClick={() => init("REFRESH")}
        >
          <ReloadIcon />
          <span className='drop-text'>Reload Menu</span>
        </div>
      </div>
      <div className='drop-divider'></div>
      <div className='item'>
        {user ? (
          <div className='flex-item'>
            <span className='drop-text username' style={{ marginLeft: 0 }}>
              {user}
            </span>
          </div>
        ) : null}
        {settingsGroup.map((group) => {
          return (
            <div
              key={group.id}
              className='flex-item text-with-icon'
              onClick={(e) => {
                e.stopPropagation();
                handleLinkClick(group.targetUrl, group.targetType === "BLANK");
                return;
              }}
            >
              {group.iconClass ? (
                <FeatherIcon icon={group.iconClass} size={24} />
              ) : null}
              {group.targetType === "BLANK" || group.targetType === "POPUP" ? (
                <a
                  href={group.targetUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='drop-text'
                >
                  {group.title}
                </a>
              ) : (
                <a href={group.targetUrl} className='drop-text'>
                  {group.title}
                </a>
              )}
            </div>
          );
        })}
        {authGroup.map((auth) => {
          if (auth.id === "sys-menu-logout") {
            return (
              <div className='flex-item' key={auth.id}>
                <button
                  className='btn btn-main'
                  onClick={(e) => {
                    e.stopPropagation();
                    handleLinkClick(
                      auth.targetUrl,
                      auth.targetType === "BLANK"
                    );
                    return;
                  }}
                >
                  {" "}
                  <LogoutIcon />
                  {auth.targetType === "BLANK" ||
                  auth.targetType === "POPUP" ? (
                    <a
                      href={auth.targetUrl}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {auth.title}
                    </a>
                  ) : (
                    <a href={auth.targetUrl}>{auth.title}</a>
                  )}
                </button>
              </div>
            );
          }

          return (
            <div
              className='flex-item'
              key={auth.targetUrl}
              style={{ marginBottom: "10px" }}
            >
              <button
                className='btn clock-out'
                onClick={(e) => {
                  e.stopPropagation();
                  handleLinkClick(auth.targetUrl, auth.targetType === "BLANK");
                  return;
                }}
              >
                <ClockIcon />
                {auth.targetType === "BLANK" || auth.targetType === "POPUP" ? (
                  <a
                    href={auth.targetUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {auth.title}
                  </a>
                ) : (
                  <a href={auth.targetUrl}>{auth.title}</a>
                )}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActionDropDown;
